"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.dataManagement")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.company.dataManagement", {
        url: "/gestao-de-dados",
        params: {},
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company-data-management" */ "./data-management.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.company.dataManagement")
            );
        },
        views: {
            "admin@nucont.accounting": {
                component: "dataManagementComponent",
                bindings: { companyData: "CompanyData" }
            }
        }
    });
}
